import { FornecedorDropDown } from "../../../../../common/domain/models/fornecedor_dropdown";
import { IGetFornecedorByFamiliaDropDownUseCase } from "../../../presentation/useCases/read/get_fornecedor_by_familia_drop_down_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetFornecedorByFamiliaDropDownUseCase
 */

export class GetFornecedorByFamiliaDropDownUseCase implements IGetFornecedorByFamiliaDropDownUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getFornecedorByFamiliaDropDown(
    familia: string,
  ): Promise<FornecedorDropDown[]> {
    return await this.repository.getFornecedorByFamiliaDropDown(
      familia,
    );
  }
}
